// Shared react-query options for CMS issuer data.
//
// CMS content (issuer logos, descriptions, contacts, news) is editorial and
// changes rarely, so we treat it as fresh for an hour — matching the 1h
// convention the GraphQL layer already uses (see getFetchPolicyOptions'
// TIME_TO_STALE) — keep it in the cache for that hour after the last consumer
// unmounts, and don't refetch just because the window regained focus.
const ONE_HOUR_MS = 60 * 60 * 1000;

export const CMS_QUERY_OPTIONS = {
  staleTime: ONE_HOUR_MS,
  // react-query v4 name for how long an unused query stays in cache (v5: gcTime).
  cacheTime: ONE_HOUR_MS,
  refetchOnWindowFocus: false,
  retry: false,
} as const;
